import { useCallback } from 'react';
import { useModal } from '../useModal';
import DateRangePickerModal from './DateRangePickerModal';

interface UseDateRangeModalOptions<V extends string = string> {
    onDateRangeSelected: (option: { label: string; value: V } | null, dateFrom: string, dateTo: string) => void;
    customOptionValue?: string;
    initialDateFrom?: string;
    initialDateTo?: string;
}

export const useDateRangeModal = <V extends string = string>({
    onDateRangeSelected,
    customOptionValue = 'custom',
    initialDateFrom,
    initialDateTo,
}: UseDateRangeModalOptions<V>) => {
    const { openModal, closeModal } = useModal();

    const handleSelectChange = useCallback(
        (newValue: { label: string; value: V } | null) => {
            if (newValue?.value === customOptionValue) {
                openModal(
                    <DateRangePickerModal
                        onCancel={closeModal}
                        onSave={(dateFrom, dateTo) => {
                            onDateRangeSelected(newValue, dateFrom, dateTo);
                            closeModal();
                        }}
                        initialDateFrom={initialDateFrom}
                        initialDateTo={initialDateTo}
                    />
                );
                return false;
            }
            return true;
        },
        [openModal, closeModal, onDateRangeSelected, customOptionValue, initialDateFrom, initialDateTo]
    );

    return {
        handleSelectChange,
    };
};
